import type { SVGProps } from "react";
import * as React from "react";

const SvgFramer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M5 16h7m-7 0V9h14V2H5l14 14H5m0 0 7 7v-7z"
    />
  </svg>
);
export default SvgFramer;
